import React, { useState } from 'react'
import { TextInput, View } from 'react-native'

import { storiesOf } from '@storybook/react-native'

import { Story, StoryScreen, UseCase } from '../../../storybook/views'
import { CardSvgs } from '../../components/card/card-svgs'
import { Board } from '../Board/Board'
import { CardLayout } from '../card/cardLayout'
import { PlayerActions } from '../PlayerActions/PlayerActions'
import { PlayerHoleCards } from '../PlayerHoleCards/PlayerHoleCards'
import { Pot } from '../Pot/Pot'
import { StoryControls } from '../StoryControls/StoryControls'
import { Grid, GridPreset } from './Grid'
import { GameStates } from '@poker-powher/poker'

enum PresetType {
  table = 'Table',
  noTable = 'NoTable',
}

storiesOf('Table', module)
  .addParameters({
    design: {
      type: 'figma',
      url: 'https://www.figma.com/file/LKQ4FJ4bTnCSjedbRpk931/Sample-File',
    },
  })
  .addDecorator((fn) => <StoryScreen>{fn()}</StoryScreen>)
  .add('Gird No Table Preset', () => {
    const Parent = ({ children, ...props }: any) => {
      const [state, setState] = useState({
        presetType: PresetType.noTable,
        value:
          '[{"id":"224219076","actions":["RAISE","CALL","FOLD"],"player":{"id":"224219076","version":6,"checkpoint":1662464679780,"name":"Harikrishnan Unnithan","userId":"63104e661b2944001037a34f","userRoles":["user"],"actions":["RAISE","CALL","FOLD"],"bet":50,"bets":[{"amount":50,"kind":"smallblind"}],"cards":["Qd","5d"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":0,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":9950,"rankedHandName":"High Card","rankedHandDescription":"Q High","doNoActionCount":0,"color":"crimson","role":"SB","events":[]},"index":0,"mappedIndex":0,"bet":50,"bets":[{"amount":50,"kind":"smallblind"}],"cards":["Qd","5d"],"chips":9950,"name":"Harikrishnan Unnithan","userId":"63104e661b2944001037a34f","role":"SB","color":"crimson","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"689166024","actions":["RAISE","CHECK"],"player":{"id":"689166024","version":6,"checkpoint":1662464679780,"name":"harry","userId":"62d0495e844921000fdb426b","userRoles":["user"],"actions":["RAISE","CHECK"],"bet":100,"bets":[{"amount":100,"kind":"bigblind"}],"cards":["Ts","5c"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":1,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":9900,"rankedHandName":"High Card","rankedHandDescription":"10 High","doNoActionCount":0,"color":"pink","role":"BB","events":[]},"index":1,"mappedIndex":1,"bet":100,"bets":[{"amount":100,"kind":"bigblind"}],"cards":["Ts","5c"],"chips":9900,"name":"harry","userId":"62d0495e844921000fdb426b","role":"BB","color":"pink","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"994179711","actions":["RAISE","CALL","FOLD"],"player":{"id":"994179711","version":5,"checkpoint":1662464679780,"name":"Vipin Patil","userId":"62cff8c10eb025000f7c0d45","userRoles":["user"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["Ac","Jh"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":5,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"A High","doNoActionCount":0,"color":"red","role":"","events":[]},"index":5,"mappedIndex":2,"bet":0,"bets":[],"cards":["Ac","Jh"],"chips":10000,"name":"Vipin Patil","userId":"62cff8c10eb025000f7c0d45","role":"","color":"red","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"189208962","actions":["RAISE","CALL","FOLD"],"player":{"id":"189208962","version":5,"checkpoint":1662464679780,"name":"krati dhawan","userId":"62cff8800eb025000f7c0ce4","userRoles":["user"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["Qs","8d"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":2,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"Q High","doNoActionCount":0,"color":"orange","role":"","events":[]},"index":2,"mappedIndex":3,"bet":0,"bets":[],"cards":["Qs","8d"],"chips":10000,"name":"krati dhawan","userId":"62cff8800eb025000f7c0ce4","role":"","color":"orange","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"657493468","actions":["RAISE","CALL","FOLD"],"player":{"id":"657493468","version":5,"checkpoint":1662464679780,"name":"PradeepLink","userId":"62a6e418fa703f000ffef061","userRoles":["user","teacher"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["6h","8c"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":4,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"8 High","doNoActionCount":0,"color":"blue","role":"","events":[]},"index":4,"mappedIndex":4,"bet":0,"bets":[],"cards":["6h","8c"],"chips":10000,"name":"PradeepLink","userId":"62a6e418fa703f000ffef061","role":"","color":"blue","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"572482678","actions":["RAISE","CALL","FOLD"],"player":{"id":"572482678","version":5,"checkpoint":1662464679780,"name":"Pradeep Choudhary","userId":"6242ae483eab99000ff00b7b","userRoles":["user","teacher"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["Ks","5s"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":3,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"K High","doNoActionCount":0,"color":"green","role":"","events":[]},"index":3,"mappedIndex":5,"bet":0,"bets":[],"cards":["Ks","5s"],"chips":10000,"name":"Pradeep Choudhary","userId":"6242ae483eab99000ff00b7b","role":"","color":"green","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}}]',
      })
      return <View style={{ flex: 1 }}>{children(state, setState)}</View>
    }
    return (
      <Parent>
        {(state: any, setState: any) => (
          <Story>
            <UseCase text="Grid" usage="Enter seat number to change the grid">
              <TextInput
                allowFontScaling={false}
                style={{ padding: 5, height: 30, borderColor: 'lightgray', borderWidth: 1, marginBottom: 20 }}
                onChangeText={(text) => setState({ ...state, value: text })}
                placeholder="Enter Seat"
                value={state.value}
              />
              {/* <Grid players={JSON.parse(state.value)} preset={GridPreset.noTable}/> */}
              <Grid
                agoraUserList={[]}
                channelName={'channelName'}
                hasLocalUserJoinedVideo={false}
                hasLocalUserMutedVideo={false}
                hasLocalUserHiddenVideo={false}
                gameState={GameStates.Playing}
                isShowdown={false}
                localUserId={'userId'}
                mainPot={3434}
                players={JSON.parse(state.value)}
                preset={GridPreset.noTable}
                onTimeoutAction={() => {}}
                showOptionModal={() => {}}
                useFourColoredCards={false}
                showCardsForAllin={false}
                isGamePaused={false}
                isGameBegin={true}
                isMyTurn={true}
                isTeacher={true}
                isCardVisible={false}
                setUserForTeacher={function (userId: string): void {
                  throw new Error('Function not implemented.')
                }}
                secondsPassed={20}
                shouldHighlightCurrentPlayer={true}
                actionTime={60}
                startingImageHeight={400}
                actionDurationLeft={40}
                hasUserTappedOnAction={false}
              />
            </UseCase>
          </Story>
        )}
      </Parent>
    )
  })
  // .add('Gird Table Preset', () => {
  //   const Parent = ({ children, ...props }: any) => {
  //     const [state, setState] = useState({
  //       value:
  //         '[{"id":"224219076","actions":["RAISE","CALL","FOLD"],"player":{"id":"224219076","version":6,"checkpoint":1662464679780,"name":"Harikrishnan Unnithan","userId":"63104e661b2944001037a34f","userRoles":["user"],"actions":["RAISE","CALL","FOLD"],"bet":50,"bets":[{"amount":50,"kind":"smallblind"}],"cards":["Qd","5d"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":0,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":9950,"rankedHandName":"High Card","rankedHandDescription":"Q High","doNoActionCount":0,"color":"crimson","role":"SB","events":[]},"index":0,"mappedIndex":0,"bet":50,"bets":[{"amount":50,"kind":"smallblind"}],"cards":["Qd","5d"],"chips":9950,"name":"Harikrishnan Unnithan","userId":"63104e661b2944001037a34f","role":"SB","color":"crimson","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"689166024","actions":["RAISE","CHECK"],"player":{"id":"689166024","version":6,"checkpoint":1662464679780,"name":"harry","userId":"62d0495e844921000fdb426b","userRoles":["user"],"actions":["RAISE","CHECK"],"bet":100,"bets":[{"amount":100,"kind":"bigblind"}],"cards":["Ts","5c"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":1,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":9900,"rankedHandName":"High Card","rankedHandDescription":"10 High","doNoActionCount":0,"color":"pink","role":"BB","events":[]},"index":1,"mappedIndex":1,"bet":100,"bets":[{"amount":100,"kind":"bigblind"}],"cards":["Ts","5c"],"chips":9900,"name":"harry","userId":"62d0495e844921000fdb426b","role":"BB","color":"pink","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"994179711","actions":["RAISE","CALL","FOLD"],"player":{"id":"994179711","version":5,"checkpoint":1662464679780,"name":"Vipin Patil","userId":"62cff8c10eb025000f7c0d45","userRoles":["user"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["Ac","Jh"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":5,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"A High","doNoActionCount":0,"color":"red","role":"","events":[]},"index":5,"mappedIndex":2,"bet":0,"bets":[],"cards":["Ac","Jh"],"chips":10000,"name":"Vipin Patil","userId":"62cff8c10eb025000f7c0d45","role":"","color":"red","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"189208962","actions":["RAISE","CALL","FOLD"],"player":{"id":"189208962","version":5,"checkpoint":1662464679780,"name":"krati dhawan","userId":"62cff8800eb025000f7c0ce4","userRoles":["user"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["Qs","8d"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":2,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"Q High","doNoActionCount":0,"color":"orange","role":"","events":[]},"index":2,"mappedIndex":3,"bet":0,"bets":[],"cards":["Qs","8d"],"chips":10000,"name":"krati dhawan","userId":"62cff8800eb025000f7c0ce4","role":"","color":"orange","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"657493468","actions":["RAISE","CALL","FOLD"],"player":{"id":"657493468","version":5,"checkpoint":1662464679780,"name":"PradeepLink","userId":"62a6e418fa703f000ffef061","userRoles":["user","teacher"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["6h","8c"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":4,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"8 High","doNoActionCount":0,"color":"blue","role":"","events":[]},"index":4,"mappedIndex":4,"bet":0,"bets":[],"cards":["6h","8c"],"chips":10000,"name":"PradeepLink","userId":"62a6e418fa703f000ffef061","role":"","color":"blue","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}},{"id":"572482678","actions":["RAISE","CALL","FOLD"],"player":{"id":"572482678","version":5,"checkpoint":1662464679780,"name":"Pradeep Choudhary","userId":"6242ae483eab99000ff00b7b","userRoles":["user","teacher"],"actions":["RAISE","CALL","FOLD"],"bet":0,"bets":[],"cards":["Ks","5s"],"state":{"tag":"inplay","description":"In Play"},"missedBlinds":false,"seatId":3,"playerOutTime":0,"buyIn":true,"event$":{"_isScalar":false,"observers":[],"closed":false,"isStopped":false,"hasError":false,"thrownError":null},"chips":10000,"rankedHandName":"High Card","rankedHandDescription":"K High","doNoActionCount":0,"color":"green","role":"","events":[]},"index":3,"mappedIndex":5,"bet":0,"bets":[],"cards":["Ks","5s"],"chips":10000,"name":"Pradeep Choudhary","userId":"6242ae483eab99000ff00b7b","role":"","color":"green","buyIn":true,"dealer":5,"bigBlindPlayer":1,"smallBlindPlayer":0,"currentPlayer":2,"myPlayer":4,"playerState":{"tag":"inplay","description":"In Play"}}]',
  //     })
  //     return <View style={{ flex: 1, minHeight: 400 }}>{children(state, setState)}</View>
  //   }
  //   return (
  //     <Parent>
  //       {(state: any, setState: any) => (
  //         <Story>
  //           <UseCase text="Grid" usage="Enter seat number to change the grid">
  //             <View style={{ backgroundColor: '#040933', minHeight: 400 }}>
  //               <TextInput
  //                 allowFontScaling={false}
  //                 style={{
  //                   padding: 5,
  //                   height: 30,
  //                   borderColor: 'lightgray',
  //                   borderWidth: 1,
  //                   marginBottom: 20,
  //                   backgroundColor: '#fff',
  //                 }}
  //                 onChangeText={(text) => setState({ ...state, value: text })}
  //                 placeholder="Enter Seat"
  //                 value={state.value}
  //               />
  //               {/* <Grid
  //                 players={JSON.parse(state.value)}
  //                 preset={GridPreset.table}
  //                 avatarMap={{}}
  //                 mainPot={3434}
  //                 hasLocalUserJoinedVideo={false}
  //                 hasLocalUserMutedVideo={false}
  //                 hasLocalUserHiddenVideo={false}
  //                 agoraUserList={[]}
  //                 showOptionModal={() => {}}
  //                 isShowdown={false}
  //                 onTimeoutAction={() => {}}
  //                 useFourColoredCards={false}
  //                 showCardsForAllin={false}
  //                 isGamePaused={false}
  //                 isGameBegin={true}
  //                 isMyTurn={false}
  //                 isTeacher={false}
  //                 isCardVisible={false}
  //                 lastPlayerAction={undefined}
  //                 resetLastAction={function (): void {
  //                   throw new Error('Function not implemented.')
  //                 }}
  //                 setUserForTeacher={function (userId: string): void {
  //                   throw new Error('Function not implemented.')
  //                 }}
  //               /> */}
  //             </View>
  //           </UseCase>
  //         </Story>
  //       )}
  //     </Parent>
  //   )
  // })
  .add('Card', () => {
    const Parent = ({ children, ...props }: any) => {
      const [state, setState] = useState({ value: '' })
      return <View>{children(state, setState)}</View>
    }
    return (
      <Parent>
        {(state: any, setState: any) => (
          <Story>
            <UseCase text="Card" usage="Enter card name to display card">
              <StoryControls
                name="Card"
                onChangeText={(text) => {
                  setState({ ...state, value: text })
                }}
              />
              <CardLayout name={state.value} />
            </UseCase>
          </Story>
        )}
      </Parent>
    )
  })
  .add('Board', () => {
    const Parent = ({ children, ...props }: any) => {
      const [state, setState] = useState({ value: [] })
      return <View>{children(state, setState)}</View>
    }
    return (
      <Parent>
        {(state: any, setState: any) => (
          <Story>
            <UseCase text="Board" usage="Enter board card name with comma seprated">
              <TextInput
                allowFontScaling={false}
                placeholder="Enter Name With Comma Seperated without space"
                style={{ padding: 5, height: 30, borderColor: 'lightgray', borderWidth: 1, marginBottom: 20 }}
                value={state.value}
                onChangeText={(text) => setState({ ...state, value: text.trim().split(',') })}
              />
              <Board isStorybook={true} communityCards={state.value} />
            </UseCase>
          </Story>
        )}
      </Parent>
    )
  })
  .add('Pot', () => {
    const Parent = ({ children, ...props }: any) => {
      const [state, setState] = useState({ points: '44444', pots: '2' })
      return <View>{children(state, setState)}</View>
    }
    return (
      <Parent>
        {(state: any, setState: any) => (
          <Story>
            <UseCase text="Pot" usage="Enter card name to display card">
              <StoryControls
                name="Pot"
                setPoints={(text) => {
                  setState({ ...state, points: text })
                }}
                setPot={(text) => {
                  setState({ ...state, pots: text })
                }}
              />
              <Pot points={state.points} pots={state.pots} />
            </UseCase>
          </Story>
        )}
      </Parent>
    )
  })
  .add('PlayerHoleCards', () => {
    const Parent = ({ children, ...props }: any) => {
      const [state, setState] = useState({ value: ['2s', '3d'] })
      return <View>{children(state, setState)}</View>
    }
    return (
      <Parent>
        {(state: any, setState: any) => (
          <Story>
            <UseCase text="PlayerHoleCards" usage="Enter board card name with comma seprated">
              <StoryControls
                name="PlayerHand"
                setPlayerHand={(text) => setState({ ...state, value: text.trim().split(',') })}
              />
              <PlayerHoleCards hand={state.value} useFourColoredCardStyle />
            </UseCase>
          </Story>
        )}
      </Parent>
    )
  })
  .add('Player Actions', () => {
    const Parent = ({ children, ...props }: any) => {
      const [state, setState] = useState({ call: 'CALL', raise: 'RAISE', fold: 'FOLD' })
      return <View>{children(state, setState)}</View>
    }
    return (
      <Parent>
        {(state: any, setState: any) => (
          <Story>
            <UseCase text="Player Actions" usage="Enter card name to display card">
              <StoryControls
                name="PlayerActions"
                onChangeName={(key, text) => {
                  if (key === 'raise') {
                    setState({ ...state, raise: text })
                  }
                  if (key === 'call') {
                    setState({ ...state, call: text })
                  }
                  if (key === 'fold') {
                    setState({ ...state, fold: text })
                  }
                }}
              />
              <PlayerActions
                disabled={false}
                playerStatus={''}
                shouldHighlightCurrentPlayer={true}
                shouldPrefoldButtonVisible={false}
                onPreFold={() => {}}
                hasUserPreFolded={false}
                hasUserTappedOnAction={false}
                isShowdownBegin={false}
                actions={[state.call, state.raise, state.fold]}
                isGamePaused={false}
                isMyPlayerOutOrFolded={false}
                isMyTurn={true}
              />
            </UseCase>
          </Story>
        )}
      </Parent>
    )
  })
